import { render, staticRenderFns } from "./MatterTakeDownRequestForm.vue?vue&type=template&id=e8fe72ca&"
import script from "./MatterTakeDownRequestForm.vue?vue&type=script&lang=js&"
export * from "./MatterTakeDownRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports